import BranchOfficesRepository from "@/data/repositories/BranchOfficesRepository";
import { IBranchOffice } from "@/domain/interfaces/IBranchOffice";


/** Representa el controlador que maneja los eventos para sucursales
  * @returns {object} Funciones del controlador
*/
const BranchOfficesController = () => {

  /** Solicita los tipos de identificación del back
    * @returns {IBranchOffice[]} branckOffices - Sucursales
  */
  const getBranchOffices = async (store:number): Promise<IBranchOffice[]> => {

    /** Instancia del Repository
    * @const {IdTypesRepository}
    */
    const idTypesRepository = BranchOfficesRepository.instance;

    const branchOffices: IBranchOffice[] = [];

    try {
      const result = await idTypesRepository.getBranchOffices(store);
      branchOffices.push(...result.data);
    } catch (error) {

    }

    return branchOffices;
  }

  /**
   * retorna la funciones del controlador
   */
  return { getBranchOffices };
};

export default BranchOfficesController;
